import { baseUri } from '../../../service/tourPlaineApi'

const suiviPepiniereBaseUri = `${baseUri}/suiviPepiniere`

/**
 * Url paginée des cultures en pépinière, appelée directement par la SpringDataTable
 */
export const IN_NURSERY_CROPS_URI = `${suiviPepiniereBaseUri}/culturesEnPepiniere`

/**
 * Url paginée des tâches à venir de la pépinière, appelée directement par la SpringDataTable
 */
export const TASKS_URI = `${suiviPepiniereBaseUri}/taches`